/* eslint-disable @typescript-eslint/no-loss-of-precision */
import * as React from 'react';
import { Numberbox } from 'ui';
import { ScreenField, ScreenFieldProps } from 'app/area/codetable/item/screen-renderer/types';
import { ReadOnlyType } from 'app/area/codetable/item/types';
import { SafetyLimit } from 'app/area/codetable/item/types-store';
import { getSafetyLimitValidation } from './safety-limit-validation';

export interface SafetyLimitWarningDeviationProps extends ScreenFieldProps {
  value: number;
  onChange: (value: number) => void;
  safetyLimit: SafetyLimit;
}

export const SafetyLimitWarningDeviation = ({ onChange, translation, readOnlyConfig, validation, value, safetyLimit }:
  SafetyLimitWarningDeviationProps) => {

  const { fieldValidation, serverValidation } =
    getSafetyLimitValidation(ScreenField.warningDeviationPercent, safetyLimit, validation);
  const validationError = fieldValidation || serverValidation;

  const readOnly = readOnlyConfig && readOnlyConfig[ReadOnlyType.all];

  return <div className="col-lg-6 col-sm-12">
    <Numberbox
      componentId="safety_limit_warning_deviation"
      readOnly={readOnly}
      label={translation ? { text: translation.warning_deviation, required: !readOnly } : undefined}
      value={value}
      onChange={onChange}
      useThousand=" "
      maxValue={999999999999999.999999999999999}
      maxDecimals={15}
      validation={validationError}
      required={!readOnly}
      textInvalidRangeError={translation.must_be_within_range}
    />
  </div>;
};
